// 简单登录态管理（单用户）。token 存 localStorage（保持登录，30 天过期）。
// 后端在 main.py 校验账密并签发 HMAC token；所有 /api/* 需携带该 token。
import { API_BASE } from './api';

const TOKEN_KEY = 'words_auth_token';

// 无痕/隐私模式下部分浏览器会禁止 localStorage 访问并抛 SecurityError,
// 这里统一兜底, 避免初始化时崩溃导致整页白屏。
function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
}
function safeSet(key, val) {
    try { localStorage.setItem(key, val); } catch (e) {}
}
function safeRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
}

export function getToken() {
    return safeGet(TOKEN_KEY) || '';
}

export function setToken(t) {
    safeSet(TOKEN_KEY, t);
}

export function clearToken() {
    safeRemove(TOKEN_KEY);
}

export function isLoggedIn() {
    return !!getToken();
}

export async function login(username, password) {
    const r = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
    });
    if (!r.ok) {
        let msg = '登录失败';
        try { msg = (await r.json()).detail || msg; } catch (e) {}
        throw new Error(msg);
    }
    const data = await r.json();
    if (data && data.token) {
        setToken(data.token);
        return true;
    }
    throw new Error('未返回 token');
}

export function logout() {
    clearToken();
}

